<template>
    <div :style="{ backgroundImage: `url(${backgroundUrl})`, backgroundSize: 'cover' }" style="height: 100vh;">
        <CRow class="ml-5 mr-5 mb-5">
            <Mainlayout></Mainlayout>
            <br /><br /><br />
        </CRow>
        <CCol sm="12" lg="8" class="mx-auto" style="width: 70%; background-size: cover; color: #fff;">
            <div>
                <CRow>
                    <CCol sm="8" style="margin:0 auto">
                        <div style="margin-top: 10%;">
                            <CCard class="b-20">
                                <h3 class="text-center text-black mt-5">Welcome Back</h3>
    
                                <CCol sm="12" style="width: 70%; background-size: cover; margin: auto; color: #fff;">
                                    <CRow class="mt-5">
                                        <div v-if="this.Error == true" class="ml-1 mr-1 mt-2 mb-2">
                                            <CAlert show color="danger" class="custom-error-message">The credentials entered is incorrect.Please try again.</CAlert>
                                        </div>
                                        <CCol sm="12">
                                            <h3 class="custom-14px text-black">Email Address</h3>
                                            <CInput type="text" class="custom-input b-50" v-model="Email" />
                                        </CCol>
                                        <CCol sm="12">
                                            <h3 class="custom-14px text-black">Password</h3>
                                            <CInput type="password" class="custom-input b-50" v-model="Password" />
                                        </CCol>
                                      
                                        <CButton type="button" class="bg-button-blue text-white m-2" block v-on:click="trylogin">Login</CButton>
                                    </CRow>
                                    <!-- <CRow>
                                           <img src="../assets/img/loginwith.png" style="max-width:100%"/>
                                <div style="width:50%">
                                <div class="text-center bg-grey b-20 p-2 m-20" style="border:none;margin:10px">
                                   <div class="border-grey">
                                    <img src="../assets/img/google-symbol 1.png" style="width:30px"/>
                                    </div>
                                    </div>
                                </div>
                                <div style="width:50%">
                                    <div class="text-center bg-grey b-20 p-2 m-20" style="border:none;margin:10px">
                                   <div class="border-grey">
                                    <img src="../assets/img/facebook-3-2 1.png" style="width:30px"/>
                                    </div>
                                    </div>
                                </div>
                            
                            </CRow> -->
                                    <div class="text-center mt-3">
                                        <label class="custom-14px poppin-font"> Don’t have an account?<span class="text-blue" v-on:click="CreateAccount">Create New</span></label>
                                    </div>
                                </CCol>
    
    
                            </CCard>
                            <br /><br />
                        </div>
                    </CCol>
                </CRow>
            </div>
        </CCol>
    
    
    </div>
</template>
 
          
<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import AnimatedNumber from "animated-number-vue";
import backgroundlight from "../assets/img/voucher-light.png";
import backgroundblue from "../assets/img/voucher-blue.png";

import backgroundVoucherUsed from "../assets/img/voucher-used.png";
import backgroundVoucherUsedRight from "../assets/img/voucher-user-right.png";

// import Translator from "vue-gtranslate";
// import "vue-gtranslate/translator.css";

Vue.use(require("vue-moment"));
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";

import Mainlayout from "../containers/AllHeaderLanding.vue";
import Footerlayout from "../containers/TheFooter.vue";

import VueAgile from "vue-agile";
Vue.use(VueAgile);

import vSelect from "vue-select";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

import _ from "lodash";
new Vue({
    el: "#navbar",

    data() {
        return {
            view: {
                topOfPage: true,
            },
            CodeAff: "",
        };
    },
    beforeMount() {
        window.addEventListener("scroll", this.handleScroll);
    },
    methods: {
        handleScroll() {
            if (window.pageYOffset > 400) {
                if (this.view.topOfPage) {
                    this.view.topOfPage = false;
                    el.setAttribute(
                        "style",
                        //"background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)"
                        "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)"
                    );
                }
            } else {
                if (!this.view.topOfPage) this.view.topOfPage = true;
                el.setAttribute(
                    "style",
                    //"background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)"
                    "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)"
                );
            }
        },
    },
});
export default {
    name: "Login",
    components: {
        Mainlayout,
        Footerlayout,
    },
    data() {
        return {
            Email: "",
            Password: "",
            backgroundlight,
            backgroundblue,
            backgroundVoucherUsed,
            backgroundVoucherUsedRight,
            Error: false,


        };
    },
    created() {
        AOS.init();
    },
    mounted() {
        window.addEventListener("scroll", this.onScroll);

        
    },
    async mounted() {
        this.GetGrade();
        this.generateRandomCodeAndNumber();
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.onScroll);
    },
    computed: {},

    methods: {
        onScroll() {
            // Get the current scroll position
            const currentScrollPosition =
                window.pageYOffset || document.documentElement.scrollTop;
            // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
            if (currentScrollPosition < 0) {
                return;
            }
            // Here we determine whether we need to show or hide the navbar
            this.showNavbar = currentScrollPosition < this.lastScrollPosition;
            // Set the current scroll position as the last scroll position
            this.lastScrollPosition = currentScrollPosition;
        },
        handleScroll() {
            if (window.pageYOffset > 1000) {
                if (this.view.topOfPage) {
                    this.view.topOfPage = false;
                } else {
                    this.view.topOfPage = true;
                }
            }
        },
        trylogin() {
            this.Error = false;

            const formData = new FormData();

            if (this.Email === "" || this.Password === "") {
                this.Error = true;
                this.Message = "Please fill up the form!";
            } else {
                formData.append("Email", this.Email);
                formData.append("Password", this.Password);

                this.$API
                    .post(this.$LoginTokenUserAffiliate, formData, { withCredentials: true })
                    .then((response) => {
                        console.log(response.data.userType); // Log the entire response object
                        if (response.data.status === 400) {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;

                        }
                        if (response.status === 200 && response.data !== null && response.data.userType !== undefined) {


                            if (response.data.status !== 400) {

                                this.userTypeAff = response.data.userType;
                                if (this.userTypeAff === "Affiliate") {
                                    this.$router.push("DashboardAffiliate");
                                    console.log("User is an affiliate");
                                } else {
                                    this.$router.push("PackagePrestige");
                                    console.log("User is not an affiliate");
                                }
                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;

                            }
                        } else {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                    })
                    .catch((error) => {
                        console.error("Error:", error); // Log any errors
                        this.Loading = false;
                        this.Error = true;
                        this.Message = error.response.data.message;
                    });
            }
        },
        CreateAccount() {
            this.$router.push("SignUpUserAffiliate");
        }

    },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&family=Montserrat&family=Poppins&display=swap");
.c-header {
    /* background: rgb(23, 77, 124);
            background: linear-gradient(92deg, #174d7c, #1b7682);
            border-bottom: 0.01px solid #1a6783;
            border-bottom: 1px solid #636f83; */
    background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%);
    border-bottom: 0;
    border-bottom: 0;
    /* color: #fff; */
}

.c-app {
    background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
    font-family: 'Montserrat', sans-serif;
}

body {
    font-family: "Montserrat", sans-serif;
    background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}

h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
    margin-bottom: 0.5rem;
    font-weight: 500;
    line-height: 1.2;
    font-family: "Montserrat", sans-serif;
}

label {
    font-family: "Montserrat", sans-serif;
}

body nav.onScroll {
    box-shadow: 0 0 10px #aaa;
    background-color: rgb(255, 255, 255);
    font-family: 'Montserrat';
    font-style: normal;
}

body nav.onScroll ul li {
    color: #10b761;
}

body nav ul {
    margin-left: 3em;
    width: 25%;
    display: flex;
    justify-content: space-between;
}

body nav ul li {
    cursor: pointer;
    font-weight: 600;
    list-style-type: none;
    color: white;
}

body {
    top: 0 !important;
    font-family: 'Montserrat', sans-serif;
}
</style>